import { devicesIconManifest } from 'app/agriculture/icons/devices/devicesIconManifest';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { createBillboardIconDataUri } from 'app/agriculture/icons/utils/map-icon-utils/createBillboardIconDataUri';
import { CesiumBillboard } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumBillboard';
import { createIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';
import { primaryColourMain } from 'app/agriculture/material';
import { useDevices } from 'app/agriculture/queries/devices/useDevices';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import {
    DeviceStatusContext,
    DeviceStatusProvider,
} from 'app/agriculture/routes/Devices/utils/status/DeviceStatusContext';
import { useContext } from 'react';
import { statusToColour } from 'app/agriculture/routes/Devices/utils/status/statusToColour';
import { useMapVisibility } from 'app/agriculture/hooks/useMapVisibility/useMapVisibility';
import { validateLevelSnapshot } from 'app/agriculture/routes/Devices/utils/validateLevelSnapshot';
import { useDeviceLocation } from 'app/agriculture/queries/devices/useDeviceLocation';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';

export function DeviceRenderer() {
    const devices = useDevices();

    return (
        <>
            {Array.from(devices).map(([id, device]) => (
                <DeviceStatusProvider key={id} deviceId={id}>
                    <DeviceMapEntity {...device} />
                </DeviceStatusProvider>
            ))}
        </>
    );
}

function DeviceMapEntity(device: Device) {
    const { id, deviceType, infrastructureId } = device;
    const { isSelected } = useSelection();
    const { isVisible } = useMapVisibility();
    const location = useDeviceLocation({ deviceId: id });
    const { status } = useContext(DeviceStatusContext);
    const ignoreLinkedMonitors =
        deviceType === 'Level Monitor' && infrastructureId !== null && isVisible('Tank');
    const levelSnapshot = useSnapshot({
        snapshotType: brandConfig[device.brand].levelSnapshotType,
        parentId: device.id,
        shelfLife: brandConfig[device.brand].snapshotShelfLife,
    });
    const validatedLevelSnapshot = validateLevelSnapshot(levelSnapshot, { device });

    if (!location || ignoreLinkedMonitors) return null;

    return (
        <CesiumBillboard
            billboardOptions={createIcon({
                id,
                coordinates: location,
                isSelected: isSelected(infrastructureId) || isSelected(id),
                image: createBillboardIconDataUri(devicesIconManifest[deviceType], {
                    color: 'white',
                    iconColor: primaryColourMain,
                    shouldIncludeStatus: true,
                    statusColor: statusToColour[status],
                    percentage: validatedLevelSnapshot?.percentageRemaining,
                }),
                isPin: false,
            })}
        />
    );
}
